import { Subject } from 'rxjs';
import { ErrorEvent } from './error-event';

// If there are any unhandled errors, they will be emitted here.

export const globalError$ = new Subject<ErrorEvent>();
